/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-return-assign */
import React from 'react';
import ReactDOM from 'react-dom';
import { styled } from 'twin.macro';

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    font-size: 22px;
    color: #7687c2;
    font-weight: 700;
    font-family: 'Arial Regular', Arial, sans-serif;
  }
`;

const ModalBody = styled.div`
  font-family: 'Arial Regular', Arial, sans-serif;
  margin-top: 30px;
  .line-header {
    font-size: 13px;
    color: #333333;
  }
  .line {
    font-family: 'Arial Bold', Arial, sans-serif;
    font-size: 24px;
    color: #363636;
    // font-style: italic;
    // font-weight: 700;
    margin-top: 8px;
  }
  .objective {
    font-weight: 700;
    font-size: 18px;
    color: #333333;
  }
`;

const Value = styled.div`
  border-radius: 5px;
  border: 1px solid #7687c2;
  font-family: 'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;
  font-weight: 700;
  color: #7687c2;
  text-align: center;
  line-height: normal;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-inline: 20px;
`;

const WonderInformation = ({ selectedWonderLine, uniqueWonderline }) => {
  const modalContent = (
    <div
      className="modal fade"
      id="wonder-information-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="wonder-information-modal"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div
            className="custom__modal__content"
            style={{ borderRadius: '10px', border: '2px solid #7687c2' }}
          >
            <ModalHeader>
              <h1>Wonder Information</h1>
              <a href="" className="custom__modal__close" data-dismiss="modal">
                <img src="/img/plus-icon.svg" alt="" />
              </a>
            </ModalHeader>
            <ModalBody>
              {uniqueWonderline && (
                <>
                  <p className="line-header">Song line</p>
                  <div
                    className="line"
                    dangerouslySetInnerHTML={{
                      __html: selectedWonderLine?.songLine,
                    }}
                  />
                </>
              )}
              {/* <h2 className="line">{selectedWonderLine?.songLine}</h2> */}
              <p className="mt-5 line-header">Learning objective</p>
              <h2 className="objective">
                {selectedWonderLine?.learningObjective}
              </h2>
              <p className="mt-5 line-header">Values</p>
              <div className="flex flex-wrap gap-6">
                {selectedWonderLine?.values.map((value) => (
                  <Value key={value}>{value}</Value>
                ))}
              </div>
            </ModalBody>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(modalContent, document.body);
};

export default WonderInformation;
